import React, { useState, useEffect, useContext } from 'react';
import { getDocs, collection, query, where, limit } from 'firebase/firestore';
import { db } from '../Firebase Functions/firebase';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { AuthContext } from '../hooks/AuthProvider'

const Container = styled.div`
  padding: 2rem;
  background: linear-gradient(to right, #e0f7fa, #f1f8e9);
  min-height: 100vh;
`;

const StyledTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 2rem;
  text-align: center;
  text-transform: uppercase;
`;

const DashboardWidgets = styled.div`
  margin-bottom: 2rem;
`;

const WidgetCard = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-left: 8px solid #1976d2;
  margin-bottom: 2rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
`;

const StyledButton = styled.button`
  background-color: #27ae60;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  width: 100%;
  max-width: 250px;
  text-align: center;
  transition: background-color 0.3s, transform 0.2s;

  &:hover {
    background-color: #219653;
    transform: translateY(-2px);
  }
`;

const ManagerDashboard = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext); // ✅ Moved outside useEffect
  const currentUserEmail = user?.email;

  const [metrics, setMetrics] = useState({
    punchLists: null,
    incidentReports: null,
    inspections: null,
    serviceUpdates: null,
  });

  useEffect(() => {
  const fetchMetrics = async () => {
    try {
      const res = await fetch('https://us-central1-landcsape-app.cloudfunctions.net/aggregateWeeklyReport');
      const data = await res.json();

      if (!data.success) throw new Error(data.error || 'Unknown error');

      setMetrics({
        punchLists: data.incompleteSubtasks, // Precomputed from Cloud Function
        incidentReports: data.inspectionsCount.preTrip + data.inspectionsCount.postTrip,
        inspections: data.inspectionsCount.preTrip, // or split as needed
        serviceUpdates: data.servicesCount, // or use sentOutCount, etc.
      });
    } catch (err) {
      console.error('❌ Error loading dashboard metrics:', err);
    }
  };

  fetchMetrics();

  const interval = setInterval(fetchMetrics, 10 * 60 * 1000);
  return () => clearInterval(interval);
}, []);




  

  return (
    <Container>
      <StyledTitle>Manager Dashboard</StyledTitle>

      <DashboardWidgets>
        <WidgetCard>
          <h3>📋 Manager Status Summary</h3>
          <p><strong>Pending Punch Lists:</strong> {metrics.punchLists ?? 'Loading...'}</p>
          <p><strong>New Incident Reports:</strong> {metrics.incidentReports ?? 'Loading...'}</p>
          <p><strong>Open Vehicle Inspections:</strong> {metrics.inspections ?? 'Loading...'}</p>
          <p><strong>Services Needing Approval:</strong> {metrics.serviceUpdates ?? 'Loading...'}</p>
        </WidgetCard>
      </DashboardWidgets>

      <ButtonContainer>
        <StyledButton onClick={() => navigate('/view-punch-lists')}>View Punch Lists</StyledButton>
        <StyledButton onClick={() => navigate('/saved-incident-reports')}>Incident Report Dashboard</StyledButton>
        <StyledButton onClick={() => navigate('/tasks')}>Punch Lists</StyledButton>
        <StyledButton onClick={() => navigate('/vehicle-maintenance')}>Truck Maintenance</StyledButton>
        <StyledButton onClick={() => navigate('/manager-job-form')}>New Service Update</StyledButton>
        <StyledButton onClick={() => navigate('/job-list')}>Services Needing Approval</StyledButton>
        <StyledButton onClick={() => window.open('https://rotoloconsultants.quickbase.com/nav/app/brspiu9w6/table/buiiqevgk/action/td', '_blank')}>
          View Client Submitted Services
        </StyledButton>
        <StyledButton onClick={() => navigate('/upload-images')}>Marketing Images</StyledButton>
        <StyledButton onClick={() => navigate('/saved-reports')}>Saved Reports</StyledButton>
        <StyledButton onClick={() => navigate('/change-of-status')}>C.O.S. Form</StyledButton>
        <StyledButton onClick={() => window.open('https://employee-safe-space.vercel.app/', '_blank')}>
          Leave Anonymous Feedback
        </StyledButton>

      </ButtonContainer>
    </Container>
  );
};

export default ManagerDashboard;
